































































































































































import { defineComponent } from '@vue/composition-api';
import useOptions from '@/components/composers/useOptions';
import useHandleDrawer from '@/components/composers/useHandleDrawer';

const SidebarContent: object = defineComponent({
  name: 'SidebarContent',
  setup() {
    return {
      ...useOptions(),
      ...useHandleDrawer(),
    };
  },
});
export default SidebarContent;
